<template>
    <div class="bussiness-site__content">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="content-icon">
            <img src="@/assets/icons/address.svg">
        </div>
        <div class="content-title">
            {{translate('own_Business')}}
        </div>
        <div class="content-subtitle">
            {{settings.subtitle}}
        </div>
        <form class="content-form">
            <div class="form-input__wrapper">
                <form autocomplete="off">
                    <div class="businessFlow__wrapper" v-if="settings.businessFlow">
                        <div class="form-input__icon">
                            <img src="@/assets/icons/ic_case.svg">
                        </div>
                        <md-autocomplete
                                :md-options="autocompleteBusinessCollection"
                                @md-changed="onSearchPlaceAutocomplete"
                                @md-selected="onSearchPlaceSelect"
                                class="autocomplete"
                                v-model="searchBusinessQuery">
                            <label>{{this.translate('own_BusinessName')}}</label>

                            <template class="businessDropdownItem" slot="md-autocomplete-item"
                                      slot-scope="{ item }">
                                <div class="businessDropdown__wrapper" v-if="item.uid">
                                    <img :src='item.preview' class="businessDropdown__image">
                                    <div class="businessDropdown__item">
                                        <md-highlight-text>{{ item.name }}</md-highlight-text>
                                        <md-highlight-text>{{ item.address }}</md-highlight-text>
                                    </div>
                                </div>
                                <div class="businessDropdown__wrapper" v-else>
                                    <div class="businessDropdown__item">
                                        <md-highlight-text>{{ item.main_text }}</md-highlight-text>
                                        <md-highlight-text>{{ item.secondary_text }}</md-highlight-text>
                                    </div>
                                </div>
                            </template>
                        </md-autocomplete>
                    </div>
                    <div class="businessFlow__wrapper" v-if="settings.siteSelectorFlow">
                        <div class="form-input__icon">
                            <img src="@/assets/icons/ic_case.svg">
                        </div>
                        <md-field>
                            <md-select v-model="placeSelectorItem">
                                <md-option :value="item.value" v-for="item in placesForSelector" :key="item.text">
                                    {{item.text}}
                                </md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div class="businessFlow__wrapper" v-if="settings.siteFlow">
                        <div class="form-input__icon">
                            <img src="@/assets/icons/ic_globe.svg">
                        </div>
                        <md-field>
                            <label>{{translate('siteAddress')}}</label>
                            <md-input
                                    type="text"
                                    v-model="webSite"
                            >
                            </md-input>
                        </md-field>
                    </div>
                    <div class="businessFlow__wrapper" v-if="settings.addressFlow">
                        <div class="form-input__icon">
                            <img src="@/assets/icons/ic_pin.svg">
                        </div>
                        <md-autocomplete
                                :md-options="autocompleteAddressCollection"
                                @md-changed="onSearchAddressChanged"
                                @md-selected="onSearchAddressSelect"
                                class="autocomplete"
                                v-model="searchAddressQuery">
                            <label>{{this.translate('own_Address')}}</label>

                            <template class="addressDropdownItem" slot="md-autocomplete-item"
                                      slot-scope="{ item }">
                                <md-highlight-text>{{ item.main_text }}</md-highlight-text>
                                <md-highlight-text>{{ item.secondary_text }}</md-highlight-text>
                            </template>
                        </md-autocomplete>
                    </div>
                </form>
            </div>

        </form>
        <div class="save-button__wrapper">
            <a @click="onSaveClick()" class="save-button">
                <b-spinner small v-if="addSiteFinishButtonSpinner"></b-spinner>
                <span v-if="settings.haveSiteQuestion">{{translate('own_SaveBtnWithQuestion')}}</span>
                <span v-else>{{translate('own_SaveBtn')}}</span>
            </a>
        </div>

    </div>
</template>

<script>
    import 'v-autocomplete/dist/v-autocomplete.css'
    // Import components
    import mapMixin from '@/mixins/mapMixin';
    import errorMixin from '@/mixins/errorMixin';
    import questionMixin from '@/mixins/questionMixin';
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import customModalDialog from '@/components/widgets/customModalDialog';
    import logAnalyticsEvent from '@/helpers/analytics'
    import _ from "lodash";

    export default {
        name: "selectBusinessFlow",

        mixins: [mapMixin, errorMixin, questionMixin],

        data() {
            return {
                searchBusinessQuery: '',
                searchAddressQuery: '',
                webSite: '',
                addSiteFinishButtonSpinner: false,
                autocompleteBusinessCollection: [],
                autocompleteAddressCollection: [],
                isActive: false,
                selectedGooglePlaceItem: null,
                selectedAirVotePlaceItem: null,
                placeSearch: '',
                placesForSelector: [{
                    text: 'test'
                }, {
                    text: 'test2'
                }],
                placeSelectorItem: null,
                customModalSettings: null,
            }
        },
        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },
        watch: {
            settings(newValue) {
                this.showInfoModal = !_.isEmpty(newValue)
            }
        },

        components: {
            customModalDialog,
        },


        computed: {
            ...mapState({
                accessToken: state => state.auth.accessToken,
                makeOwnerBool: state => state.owner.makeOwnerBool,
                userInfo: state => state.auth.userInfo
            }),

            ...mapGetters({
                isUserAdmin: 'auth/isUserAdmin',
                isUserClient: 'auth/isUserClient',
                isUserOwner: 'auth/isUserOwner',
                isUserOrgManager: 'auth/isUserOrgManager',
                isUserSiteManager: 'auth/isUserSiteManager',
                hasOwnOrganization: 'auth/hasOwnOrganization',
                hasOwnPlace: 'auth/hasOwnPlace',
                ownPlaces: 'auth/ownPlaces',
                getOwnPlace: 'auth/getOwnPlace',
                siteManagerPlaces: 'auth/siteManagerPlaces',
                isAddSite: 'organization/isAddSite',
                hasOrgManagerPlace: 'auth/hasOrgManagerPlace',
                orgManagerPlaces: 'auth/orgManagerPlaces',
            }),
        },

        mounted() {
            if (this.settings.siteSelectorFlow) {
                let places = []
                if (this.isUserOwner) {
                    places = this.ownPlaces
                } else if (this.isUserOrgManager) {
                    places = this.orgManagerPlaces
                } else if (this.isUserSiteManager) {
                    places = this.siteManagerPlaces
                }
                this.setupPlacesSelectorList(places)
            }
        },

        methods: {
            ...mapActions({
                searchPlaceAutocomplete: 'search/searchPlaceAutocomplete',
                searchAddressAutocomplete: 'search/searchAddressAutocomplete',
                fetchPlace: 'place/fetchPlace',
                createPlaceAction: 'place/createPlace',
                connectOwnerToPlace: 'place/connectOwnerToPlace',
                connectQuestionToPlace: 'question/connectQuestionToPlace',
                fetchUserInfo: 'auth/fetchUserInfo',
                addSite: 'owner/addSite',
                fetchSelectedStartTemplates: 'question/fetchSelectedStartTemplates',
                connectSelectedStartTemplates: 'question/connectSelectedStartTemplates',
                clearSelectedStartTemplates: 'question/clearSelectedStartTemplates',
                updateProfileLang: 'profiles/updateProfileLang',
            }),


            ...mapMutations({
                setLanguage: 'setLanguage',
            }),

            getLabel(item) {
                if (item) {
                    return item.main_text || item
                }
                return ''
            },

            async onSearchPlaceSelect(place) {
                if (!place.uid) {
                    this.selectedAirVotePlaceItem = null
                    this.handleSelectedGooglePlace(place.placeId)
                } else {
                    this.selectedGooglePlaceItem = null
                    this.selectedAirVotePlaceItem = place
                    this.searchBusinessQuery = place.name
                    this.searchAddressQuery = place.address
                    this.webSite = place.website
                }
            },

            async onSearchAddressSelect(address) {
                this.searchAddressQuery = address.description
            },

            async onSearchPlaceAutocomplete(searchText) {
                this.autocompleteBusinessCollection = new Promise((resolve, reject) => {
                    this.searchPlaceAutocomplete(searchText)
                        .then((response) => {
                            let res = response.sites.concat(response.items)
                            for (let i = 0; res.length > i; i++) {
                                let item = res[i]
                                let name = item.uid != null ? item.name : item.main_text
                                item.toLowerCase = () => name.toLowerCase()
                                item.toString = () => name
                            }
                            resolve(res);
                        })
                        .catch((error) => {
                            reject(error.response);
                        });
                });
            },

            getAutocompleteAddressCollection() {
                this.autocompleteAddressCollection = new Promise((resolve, reject) => {
                    this.searchAddressAutocomplete({searchText: this.searchAddressQuery, isGeocode:false})
                        .then((response) => {
                            let res = response.items
                            for (let i = 0; res.length > i; i++) {
                                let item = res[i]
                                item.toLowerCase = () => item.description.toLowerCase()
                                item.toString = () => item.description
                            }
                            resolve(res);
                        })
                        .catch((error) => {
                            reject(error.response);
                        });
                });
            },

            async onSearchAddressChanged() {
                this.getAutocompleteAddressCollection()
            },

            onCloseSearch() {
                //todo use
                this.autocompleteBusinessCollection = []
                this.searchBusinessQuery = ''
                this.$store.commit("setSessionToken", null)
            },

            async createNewSite(place_id) {
                try {
                    const response = await this.addSite({place_id})
                    this.skipClose = true
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            },

            async handleSelectedGooglePlace(placeId) {
                this.addSiteFinishButtonSpinner = true
                try {
                    const response = await this.createPlaceAction(placeId)
                    console.log(response)
                    if (response.success) {
                        this.selectedGooglePlaceItem = response.place
                        this.searchBusinessQuery = this.selectedGooglePlaceItem.place_name
                        this.searchAddressQuery = this.selectedGooglePlaceItem.address
                        this.webSite = this.selectedGooglePlaceItem.site_url
                    } else {
                        this.showErrorModal(response.error.message, {
                            title: 'Error',
                            code: response.error.code
                        })
                    }
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                    this.addSiteFinishButtonSpinner = false
                }
            },

            onSaveClick() {
                if (this.addSiteFinishButtonSpinner) {
                    logAnalyticsEvent(`select_business_spinactive_save_click`)
                    return;
                }
                if (this.settings.siteSelectorFlow) {
                    console.log(`placeSelectorItem:`, this.placeSelectorItem)
                    //todo check if valid this.placeSelectorItem
                    this.settings.onOkHandler({place_id: this.placeSelectorItem})
                    return
                }
                if (!this.searchBusinessQuery || this.searchBusinessQuery === '') {
                    logAnalyticsEvent(`select_business_empty_save_click`)
                    this.customModalSettings = {
                        icon: 'ic_allow.svg',
                        title: this.translate('own_PleaseStartWriting') //todo change text  to "Please enter business name"
                    }
                    return
                }
                this.addSiteFinishButtonSpinner = true
                let dataChanged = this.checkSelectedDataChanged()
                let item = this.generatePlaceObject(dataChanged)
                logAnalyticsEvent(`select_business_save_clk_gen_place`)
                this.settings.onOkHandler(item)
            },

            checkSelectedDataChanged() {
                if (this.selectedGooglePlaceItem == null && this.selectedAirVotePlaceItem == null) {
                    return true
                }
                if (this.selectedGooglePlaceItem != null) {
                    return this.searchBusinessQuery !== this.selectedGooglePlaceItem.place_name
                        || this.searchAddressQuery !== this.selectedGooglePlaceItem.address
                        || this.webSite !== this.selectedGooglePlaceItem.site_url
                }
                if (this.selectedAirVotePlaceItem != null) {
                    let changedAirVotePlace = this.searchBusinessQuery !== this.selectedAirVotePlaceItem.name
                        || this.searchAddressQuery !== this.selectedAirVotePlaceItem.address
                        || this.webSite !== this.selectedAirVotePlaceItem.website
                    console.log(`changedAirVotePlace:${changedAirVotePlace}`)
                    return changedAirVotePlace
                }
            },

            generatePlaceObject(dataChanged) {
                if (this.selectedGooglePlaceItem == null && this.selectedAirVotePlaceItem == null || dataChanged) {
                    let item = {
                        name: this.searchBusinessQuery,
                        address: this.searchAddressQuery,
                        website: this.webSite,
                    }
                    return item
                }
                if (this.selectedGooglePlaceItem != null) {
                    this.selectedGooglePlaceItem.name = this.selectedGooglePlaceItem.place_name
                    this.selectedGooglePlaceItem.website = this.selectedGooglePlaceItem.site_url
                    return this.selectedGooglePlaceItem
                }
                if (this.selectedAirVotePlaceItem != null) {
                    return {
                        place_id: this.selectedAirVotePlaceItem.uid
                    }
                }
            },

            setupPlacesSelectorList(items) {
                this.placesForSelector = []
                if (items.length) {
                    items.forEach(item => {
                        this.placesForSelector.push({
                            text: item.name,
                            value: item.uid
                        })
                    })
                    this.placeSelectorItem = this.placesForSelector[0].value
                }
            },

            contactUs() {
                if (!this.placeSearch) {
                    window.open(`mailto:team@air-vote.com?subject=${this.translate('own_CanNotFind')} ${this.searchBusinessQuery}`)
                } else {
                    window.open(`mailto:team@air-vote.com?subject=${this.translate('own_CanNotFind')} ${this.placeSearch.description}`)
                }
            }
        },


    }
</script>

<style>
    .md-menu-content {
        z-index: 9999 !important;
        min-width: 295px !important;
        max-width: 1440px !important;
    }

    .businessFlow__wrapper {
        display: flex;
        align-items: center;
    }

    .bussiness-site__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 65px 30px 65px;
    }

    .content-icon {
        margin-top: 36px;
    }

    .content-form {
        margin-right: 15px;
    }

    .content-title {
        margin-top: 21px;
        color: #2F2F2F;
        font-family: Nunito;
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 28px;
    }

    .content-subtitle {
        margin-top: 21px;
        color: #2F2F2F;
        font-family: Nunito;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
        width: 338px;
        text-align: center;
    }


    .form-input__wrapper {
        display: flex;
        align-items: center;
        position: relative;
        margin-top: 20px;
    }

    input {
        border: none;
        box-shadow: none;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        padding-top: 5px;
    }

    .form-input__icon {
        margin-right: 8px;
    }

    .save-button__wrapper {
        margin-top: 25px;
        cursor: pointer;
    }

    .save-button {
        color: white !important;
        font-family: Nunito;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 24px;
        border-radius: 6px;
        background-color: #3F405C;
        padding: 12px 92px;
        text-decoration: none;
        outline: none;
    }

    .save-button:hover {
        text-decoration: none !important;
        color: white;
        outline: none;
        border: none;
    }


    @media screen and (max-width: 426px) {
        .content-icon {
            margin-top: 0;
        }

        .save-button {
            padding: 12px 9px;
        }
    }

    @media screen and (max-width: 321px) {
        .content-subtitle {
            width: 265px;
        }
        .save-button {
            padding: 12px 5px;
        }
    }

    .md-list-item-container:not(.md-list-item-default):not([disabled]) > .md-list-item-content {
        display: flex;
        align-items: baseline;
        min-height: auto;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: -webkit-flex;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-align-items: baseline;
        -ms-flex-align: baseline;
    }

    .businessDropdown__wrapper {
        display: flex;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: -webkit-flex;
    }

    .businessDropdown__image {
        width: 50px;
        height: 50px;
        max-width: 50px !important;
        max-height: 50px !important;
        margin-right: 5px;
    }

    .businessDropdown__item {
        display: flex;
        flex-direction: column;
    }


</style>
<style scoped>

    .md-menu-content .md-theme-default:last-child {
        font-size: small;
        color: gray;
    }

    .address__text {
        font-weight: 500;
        color: black;
    }

    .md-field {
        width: 335px;
    }

    .md-field label {
        color: #6D6D6D;
    }

    .content-icon {
        margin-top: 15px;
    }

    @media screen and (max-width: 376px) {
        .md-field {
            width: 300px;
        }

    }
</style>